import React, { Component } from "react";
import { isValidPasswordFormat } from "../../utils/validations";
import * as authService from "../../services/auth/auth-service";
import * as Loader from "../../common/common";

let disable = true;
export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  state = {
    resetPassword: {
      password: "",
    },
    validationErrors: {},
    msg: "",
    err: "",
  };
  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({
      resetPassword: {
        ...this.state.resetPassword,
        [name]: value,
      },
    });
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "password") {
      if (value) {
        if (value.length < 8) {
          validationErrors.passwordError = "Password too short";
        } else if (!isValidPasswordFormat(value)) {
          validationErrors.passwordError =
            "Password should contain atleast 1 uppercase 1 lowercase 1 digit and 1 special character.";
        } else {
          validationErrors.passwordError = "";
        }
        if (
          this.state.resetPassword.repeatPassword &&
          this.state.resetPassword.repeatPassword !== value
        ) {
          validationErrors.repeatPasswordError =
            "Password and Repeat Password must be same";
        } else {
          validationErrors.repeatPasswordError = "";
        }
      }
    }
    if (name === "repeatPassword") {
      if (value) {
        if (
          this.state.resetPassword.password &&
          this.state.resetPassword.password !== value
        ) {
          validationErrors.repeatPasswordError =
            "Password and Repeat Password must be same";
        } else {
          validationErrors.repeatPasswordError = "";
        }
      }
    }
    this.setState({
      validationErrors: validationErrors,
    });
  }
  async onSubmit() {
    Loader.showLoader();
    let { password, repeatPassword } = this.state.resetPassword;
    let { passwordError, repeatPasswordError } = this.state.validationErrors;
    if (password && repeatPassword && !passwordError && !repeatPasswordError) {
      var data = { password };
      let { response, err } = await authService.changePassword(data);
      Loader.hideLoader();
      if (err) {
        this.setState({
          resetPassword: {},
          error: err,
          msg: "",
        });
      } else if (response.data && response.data.err) {
        this.setState({
          resetPassword: {},
          error: response.data.err,
          msg: "",
        });
      } else {
        this.setState({
          resetPassword: {},
          msg: response.data.msg,
          error: "",
        });
      }
    } else {
      Loader.hideLoader();
    }
  }

  disableButton() {
    let { password, repeatPassword } = this.state.resetPassword;
    let { passwordError, repeatPasswordError } = this.state.validationErrors;
    if (!password || !repeatPassword || passwordError || repeatPasswordError) {
      disable = true;
    } else {
      disable = false;
    }
  }
  render() {
    this.disableButton();
    let { msg, err } = this.state;
    let { passwordError, repeatPasswordError } = this.state.validationErrors;
    let { password, repeatPassword } = this.state.resetPassword;
    return (
      <React.Fragment>
        <div className="app flex-row align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="card mx-4">
                  <div className="card-body p-4">
                    <div>
                      <h1>Change Password</h1>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-lock"></i>
                          </span>
                        </div>
                        <input
                          className={
                            passwordError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          type="password"
                          placeholder="Password"
                          name="password"
                          value={password || ""}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                      </div>
                      <div className="form-group">
                        <span className="error-msg">{passwordError}</span>
                      </div>
                      <div className="input-group mb-4">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="icon-lock"></i>
                          </span>
                        </div>
                        <input
                          className={
                            repeatPasswordError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          type="password"
                          placeholder="Repeat Password"
                          name="repeatPassword"
                          value={repeatPassword || ""}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                      </div>
                      <div className="form-group">
                        <span className="error-msg">{repeatPasswordError}</span>
                      </div>
                      <button
                        className="btn btn-block btn-success"
                        type="button"
                        disabled={disable}
                        onClick={this.onSubmit}
                      >
                        Submit
                      </button>
                      {msg ? (
                        <span style={{ color: "green" }}>{msg}</span>
                      ) : null}
                      {err ? <span style={{ color: "red" }}>{err}</span> : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
